import {
  ExportOutlined,
  PlusOutlined,
  SearchOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { Button, Input, Row, Space } from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../../components/Layout";
import { useMatStyles } from "./style";
import CustomTable from "../../../components/CustomTable/index3";
import styled from "styled-components";
import {
  Box,
  TableCell,
  TableRow,
  Grid as MatGrid,
  Paper,
} from "@mui/material";
import { getComparator, stableSort } from "../../../utils/helper";
import { customBaseUrl, httpGet, httpPost, httpPut } from "../../../store/http";
import { hideLoader, showLoader } from "../../../utils/loader";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import AntDropdown from "../../../components/CustomDropdown/AntDropdown";
import ExportData from "../../WayaOfficial/modal/exportData";
import ViewDocModal from "../../../components/Modal/ViewDoc";
import Swal from "sweetalert2";
import Reason from "./reason";
import ViewNinDocModal from "../../../components/Modal/ViewDoc/ninPhoto";
import { ProfileContext } from "../../../store/context/ProfileContext";

const Container = `styled.div`;




const NinDoc = () => {
  const navigate = useNavigate();
  const [orderData, setOrderData] = useState({
    order: "asc",
    orderBy: "businessName",
  });
  const [search, setSearch] = useState({
    searchBy: "businessName",
    searchText: "",
  });
  const { profile } = useContext(ProfileContext);
  const [metaData, setMetaData] = useState(0);
  const [pagination, setPagination] = useState({ current: 0, pageSize: 10 });
  const [selectedfield, setSelectedField] = useState('All CAC Documents');
  const [pendingData, setPendingData] = useState([]);
  const [completedData, setCompletedData] = useState([]);
  const [rejectedData, setRejectedData] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [stat, setStat] = useState([])
  const [tierStat, setTierStat] = useState([]);
  const [showExport, setShowExport] = useState(false);
  const [searchField, setSearchField] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [filteredDate, setFilteredDate] = useState([]);
  const [showViewDocModal, setShowViewDocModal] = useState(false);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [reason, setReason] = useState('');
  const [viewData, setViewData] = useState({});
  const [field, setField] = useState(null);
  const [value, setValue] = useState(null);
  const [selectedRow, setSelectedRow] = useState({});
  const styles = useMatStyles();


  const handleVerify = async (verificationId, nin) => {
    showLoader();
    const res = await httpPost(
      `${customBaseUrl.kycUrl}/api/v1/admin/face-verification/verify?regNo=${nin}&verificationId=${verificationId}`,
      {}
    );
    if (res.status) {
      hideLoader();
      setViewData({
        userImage: res.data?.userImage,
        ninImage: res.data?.ninData?.photo,
        ninFirstName: res.data?.ninData?.firstname,
        ninLastName: res.data?.ninData?.surname,
        ninMiddleName: res.data?.ninData?.middlename,
        userFirstName: res.data?.userFirstName,
        userLastName: res.data?.userLastName,
        // title: res.data?.dataType,
      });
      if (res.code === 404) {
        Swal.fire("error", res.message);
        return;
      }
      setShowViewDocModal(true);
    } else {
      hideLoader();
      setShowViewDocModal(false);
      Swal.fire("error", res.message);
    }
  };

  const dropDownOptions = ["Update KYC", "View Doc"];
  const handleDropdownAction = (item, row) => {
    setSelectedRow(row);

    if (item === "Update KYC") navigate(`/users_kyc/${row.userId}`);
    if (item === "VIEW DOCUMENT") {
      //   setViewData({
      //     url: row?.docUrl,
      //     title: row?.dataType,
      //   });
      //   setShowViewDocModal(true);
      handleVerify(row?.verificationId, row?.nin);
      setSelectedRow(row);
    }
    if (item === "APPROVE") {
      setSelectedRow(row);
      handleApprove(row, "APPROVED");
    }
    if (item === "REJECT") {
      setShowReasonModal(true);
      setSelectedRow(row);
      //  approveReject(row, "REJECTED");
    }

  };

  const handleApprove = async (row) => {
    showLoader();
    let res;
    let res2;
    res = await httpPost(
      `${customBaseUrl.kycUrl}/api/v1/admin/face-verification/${row.verificationId ?? selectedRow.verificationId}/approve`,
      {
        "adminId": profile?.userId,
        "remarks": "Approved",
      }
    );

    if (res?.status) {
      hideLoader();
      setShowReasonModal(false);
      setReason('');
      Swal.fire('Done', res?.message, 'success')
      getUsers();
    } else {
      hideLoader();
      setShowReasonModal(false);
      setReason('');
      Swal.fire('error', res?.message)
    }
  }

  const handleReject = async () => {
    showLoader();
    let res;
    let res2;
    res = await httpPost(
      `${customBaseUrl.kycUrl}/api/v1/admin/face-verification/${selectedRow.verificationId}/reject`,
      {
        "adminId": profile?.userId,
        "remarks": reason,
      }
    );

    if (res?.status) {
      hideLoader();
      setShowReasonModal(false);
      setShowViewDocModal(false);
      setReason('');
      Swal.fire('Done', res?.message, 'success')
      getUsers();
    } else {
      hideLoader();
      setShowReasonModal(false);
      setReason('');
      Swal.fire('error', res?.message)
    }
  }

  const approveDoc = async (row, status) => {

    const res2 = await httpPut(
      `${customBaseUrl.kycUrl}/api/v1/admin/kyc/cac/approveOtherDocs/${row?.id}/${row?.businessRequirementId}?reason=${reason}&status=${status}`
    );
    if (res2.status) {
      hideLoader();
      setShowReasonModal(false);
      approvalNoti(row, status, reason);
      setReason('');
      approveDirector(row, status);
      Swal.fire('Done', res2?.message, 'success')
      getKycStat();
      getUsers();
    } else {
      hideLoader();
      setShowReasonModal(false);
      setReason('');
      Swal.fire('error', res2?.message)
    }
  };
  const approveDirector = async (row, status) => {
    if (!row?.director) return;
    const res = await httpPut(
      `${customBaseUrl.kycUrl}/api/v1/admin/kyc/cac/approveDirector/${row?.director?.id}?status=${status}`
    );
    if (res.status) {
      Swal.fire('Done', res?.message, 'success');
    }
  };

  const approvalNoti = async (item, status, reason) => {
    showLoader();
    const data = {
      attachment: 'string',
      data: {
        message: `Your ${item?.docType} document has been ${status}`,
        names: [
          {
            email: item?.createdBy,
            fullName: item?.businessName,
          },
        ],
      },
      eventCategory: 'WELCOME',
      eventType: 'EMAIL',
      htmlCode: `<p>${reason ? `Reason: ${reason}` : ''}</p>`,
      initiator: 'Admin',
      productType: 'WAYABANK',
      subject: `Document approval status`,
    };
    const res = await httpPost(`${customBaseUrl.notificationUrl}/email-notification`,
      data
    );
    if (res.status === true) {
      hideLoader();
    } else {
      hideLoader();
    }
  };

  const allColumns = [

    {
      field: 'id',
      headerName: 'ID',
      width: 25,
      headerClassName: styles.tableHeader

    },
    {
      field: 'businessName',
      headerName: 'Name',
      width: 250,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => `${row?.firstName} ${row?.lastName}`

    },

    /*{ field: 'customerPhoneNumber',
    headerName: "Phone Number",
    width: 200 ,
    headerClassName: styles.tableHeader,
 
    },
    { field: 'kycTier',
    headerName: "Tier Level",
    width: 150 ,
    headerClassName: styles.tableHeader,
    renderCell: ({row})=> row?.kycTier?.name.replace('_',' ')
 
       
    },*/
    {
      field: 'email',
      headerName: "Email",
      width: 250,
      headerClassName: styles.tableHeader,
      // renderCell: ({row})=> row?.kycStatus?.processed==='true'?'Completed':row?.kycStatus?.processed==='false'?'Under Review':'Not Completed'


    },
    {
      field: 'nin',
      headerName: "NIN",
      width: 150,
      headerClassName: styles.tableHeader,
    },

    {
      field: 'status',
      headerName: "Status",
      width: 150,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => row?.status.replace('_', ' ')

    },
    //   { field: 'approvedBy',
    //     headerName: "Approved By",
    //     width: 150 ,
    //     headerClassName: styles.tableHeader,
    //     renderCell: ({row})=> row?.approvedBy ?? 'N/A'

    //     },
    {
      field: 'createdAt',
      headerName: "Created At",
      width: 250,
      headerClassName: styles.tableHeader,
      // renderCell: ({row})=> row?.stat

    },
    // { field: 'approvedAt',
    //   headerName: "Approved At",
    //   width: 250 ,
    //   headerClassName: styles.tableHeader,

    //   },


    {
      field: "ids",
      headerName: "Action ",
      width: 80,
      align: "right",
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => (
        <AntDropdown
          dropDownOptions={["VIEW DOCUMENT", "APPROVE", "REJECT"]}
          handleDropdownAction={(item) => handleDropdownAction(item, row)}
          userId={row}
          isArrow
        />
      ),

    },
  ];

  const columns = [

    {
      field: 'id',
      headerName: 'Customer Id',
      width: 250,
      headerClassName: styles.tableHeader

    },
    {
      field: 'businessName',
      headerName: 'Business Name',
      width: 250,
      headerClassName: styles.tableHeader

    },
    {
      field: 'firstName',
      headerName: 'First Name',
      width: 250,
      headerClassName: styles.tableHeader

    },
    {
      field: 'lastName',
      headerName: 'Last Name',
      width: 250,
      headerClassName: styles.tableHeader

    },
    {
      field: 'phone',
      headerName: 'Phone Number',
      width: 250,
      headerClassName: styles.tableHeader

    },
    {
      field: 'email',
      headerName: 'Email',
      width: 250,
      headerClassName: styles.tableHeader

    },
    {
      field: 'dob',
      headerName: 'Date of Birth',
      width: 250,
      headerClassName: styles.tableHeader

    },
    {
      field: 'ownershipCut',
      headerName: 'Ownership Cut',
      width: 250,
      headerClassName: styles.tableHeader

    },

    {
      field: 'lga',
      headerName: 'LGA',
      width: 250,
      headerClassName: styles.tableHeader

    },

    {
      field: 'state',
      headerName: 'State',
      width: 250,
      headerClassName: styles.tableHeader

    },
    {
      field: 'nationality',
      headerName: 'Nationality',
      width: 250,
      headerClassName: styles.tableHeader

    },

    {
      field: 'address',
      headerName: 'Address',
      width: 250,
      headerClassName: styles.tableHeader

    },
    {
      field: 'nextOfKinFirstName',
      headerName: 'Next of Kin First Name',
      width: 250,
      headerClassName: styles.tableHeader

    },
    {
      field: 'nextOfKinLastName',
      headerName: 'Next of Kin Last Name',
      width: 250,
      headerClassName: styles.tableHeader

    },
    {
      field: 'nextOfKinPhone',
      headerName: 'Next of Kin Phone',
      width: 250,
      headerClassName: styles.tableHeader

    },
    {
      field: 'nextOfKinEmail',
      headerName: 'next of Kin Email',
      width: 250,
      headerClassName: styles.tableHeader

    },
    {
      field: 'nextOfKinAddress',
      headerName: 'Next ofKin Address',
      width: 250,
      headerClassName: styles.tableHeader

    },


    /*{ field: 'customerPhoneNumber',
    headerName: "Phone Number",
    width: 200 ,
    headerClassName: styles.tableHeader,
 
    },
    { field: 'kycTier',
    headerName: "Tier Level",
    width: 150 ,
    headerClassName: styles.tableHeader,
    renderCell: ({row})=> row?.kycTier?.name.replace('_',' ')
 
       
    },*/

    {
      field: 'status',
      headerName: "Status",
      width: 150,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => row?.status.replace('_', ' ')

    },


    {
      field: "ids",
      headerName: "Action ",
      width: 80,
      align: "right",
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => (
        <AntDropdown
          dropDownOptions={["APPROVE", "REJECT"]}
          handleDropdownAction={(item) => handleDropdownAction(item, row)}
          userId={row}
          isArrow
        />
      ),

    },
  ];

  const handleChangePage = async (newPage) => {
    setPagination({ ...pagination, current: newPage });
    // await getUsers(newPage, newPage, pagination.pageSize);

  };
  const handleChangeRowsPerPage = async (e) => {
    setPagination({ ...pagination, current: 1, pageSize: e });
    //await getUsers(e,1, e);
  };
  const handleOpenTierLevels = (Id) => {
    navigate(`/users_kyc/${Id}`);
  };
  const handleRequestSort = (event, property) => {
    const { order, orderBy } = orderData;
    const isAsc = orderBy === property && order === "asc";
    setOrderData(
      isAsc
        ? { order: "desc", orderBy: property }
        : { order: "asc", orderBy: property }
    );
  };

  const getPendingKYC = async () => {
    showLoader();
    const res = await httpGet(
      `${customBaseUrl.kycUrl}/kyc/count/totalPendingStatus`
    );
    if (res.status) {
      hideLoader();
      setPendingData(res.data);
    } else {
      hideLoader();
    }


    return [];
  };

  const getKycStat = async () => {
    let res = await httpGet(`${customBaseUrl.kycUrl}/api/v1/admin/kyc/cac/analysis`)
    if (res.status) {
      setStat(res.data)
    }
  }
  const getTierStat = async () => {
    let res = await httpGet(`${customBaseUrl.kycUrl}/kyc/tier/count-users-by-tier`)
    if (res.status) {
      setTierStat(res.data)
    }
  }

  function clean(obj) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === '') {
        delete obj[propName];
      }
    }
    return obj
  }

  const getUsers = async (e, page, size) => {
    e?.preventDefault();

    showLoader();
    const pages = page === 0 ? 0 : page ? page : pagination.current;
    const limit = size ? size : pagination.pageSize;
    let response;
    response = await httpGet(
      `${customBaseUrl.kycUrl}/api/v1/admin/face-verification/pending?direction=desc&page=${pages}&size=${limit}&sortBy=createdAt
`
    );

    if (response?.code === 200) {
      hideLoader();
      setUsersData(response?.data?.content)
      setMetaData(response?.data?.totalItems);


    } else {
      hideLoader();

    }

  };

  useEffect(() => {
    //   getKycStat()
    //   getPendingKYC();
    //   getTierStat();
  }, []);
  useEffect(() => {
    getUsers()
  }, [pagination?.pageSize, pagination.current, selectedfield]);

  // Avoid a layout jump when reaching the last page with empty rows.

  const category = ['userId', 'status', 'name', 'email', 'phoneNumber']
  const sCategory = ['INITIATED', 'UNDER_REVIEW', 'PENDING', 'APPROVED', 'REJECTED']
  const fields = ['All CAC Documents', 'Shareholders', 'Directors']


  return (
    <>

      <Container>

        <div style={{ height: 800, width: "100%" }}>
          {usersData?.length > 0 && <DataGrid
            className={styles.table}
            density="comfortable"
            rows={usersData}
            columns={selectedfield !== 'All CAC Documents' ? columns : allColumns}
            page={pagination.current}
            pageSize={pagination.pageSize}
            onPageSizeChange={(newPageSize) =>
              handleChangeRowsPerPage(newPageSize)
            }
            paginationMode="server"
            onPageChange={(newPage) => handleChangePage(newPage)}
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            pagination
            components={{ Toolbar: GridToolbar }}
            rowCount={metaData}
          />}
        </div>

        {showViewDocModal ? (
          <ViewNinDocModal
            showModal={showViewDocModal}
            hideModal={setShowViewDocModal}
            handleApprove={handleApprove}
            handleReject={() => setShowReasonModal(true)}
            data={viewData}
          />
        ) : (
          ""
        )}
      </Container>
      {showExport &&
        <ExportData showModal={showExport} hideModal={setShowExport} dataList={usersData} file={"KYC users tier "} />
      }
      {showReasonModal &&
        <Reason
          showModal={showReasonModal}
          hideModal={setShowReasonModal}
          handleSubmit={handleReject}
          selectedRow={selectedRow}
          reason={reason}
          setReason={setReason}
        />
      }
    </>
  );
};
export default NinDoc;
const gridStyle = {
  width: "23%",
  textAlign: "left",
  backgroundColor: "#fff",
  padding: "24px 10px 24px 12px",
  fontWeight: "bold",
  marginLeft: "10px",
};

const tool = {
  display: "flex",
  borderRadius: "250px",
  justifyContent: "space-between",
  marginBottom: "30px",
};
